export default "__VITE_PUBLIC_ASSET__91c4f189__"